
import {buildAlignmentScores} from './buildAlignmentScores';
import {mapCultureType} from './mapCultureType';
import {formatConfidence} from './utils';
import type {ApiWorkforceProfileRecord} from './workforceProfileApiTypes';
import type {CompanyWorkforceProfile} from '../../types/WorkforceProfileTypes';

export const normalizeWorkforceProfile = (raw: ApiWorkforceProfileRecord): CompanyWorkforceProfile => {
  const companyDepartment = raw.companyDepartment as CompanyWorkforceProfile['companyDepartment'];
  const companyDepartmentTargetProfile =
    raw.companyDepartmentTargetProfile as CompanyWorkforceProfile['companyDepartmentTargetProfile'];
  const analysis = raw.targetProfileAlignmentAnalysis as ApiWorkforceProfileRecord | undefined;
  const digest = analysis?.alignmentDigest as ApiWorkforceProfileRecord | undefined;

  return {
    resourceId: String(raw.resourceId ?? ''),
    publicId: (raw.publicId as string | null | undefined) ?? null,
    seniority: String(raw.seniority ?? ''),
    status: (raw.status as string | null | undefined) ?? null,
    analysisVersion: (raw.analysisVersion as number | null | undefined) ?? null,
    companyDepartmentId: String(raw.companyDepartmentId ?? '') || companyDepartment?.resourceId || '',
    companyDepartmentTargetProfileId:
      String(raw.companyDepartmentTargetProfileId ?? '') || companyDepartmentTargetProfile?.resourceId || '',
    createdAt: (raw.createdAt as string | null | undefined) ?? null,
    analyzedAt: (raw.analyzedAt as string | null | undefined) ?? null,
    confidence: formatConfidence(digest?.confidence as string | undefined),
    companyDepartment,
    companyDepartmentTargetProfile,
    cultureType: mapCultureType(raw.cultureType as ApiWorkforceProfileRecord | undefined) ?? undefined,
    alignment: buildAlignmentScores(raw),
  };
};
